import GATSBY_COMPILED_MDX from "/opt/build/repo/src/files/news/news-kw41-rebranding-mehr-als-facelift.md";
import React, {useRef} from 'react';
import Layout from '../components/layout';
import Contact from '../components/contact';
import {Container, Row, Col} from 'react-bootstrap';
import {config} from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCalendar, faClock, faUser} from '@fortawesome/free-solid-svg-icons';
import SEOIMG from '../img/seo.gif';
import SEA from '../img/sea.gif';
import CRO from '../img/cro.gif';
import DESIGN from '../img/design.gif';
import DEV from '../img/dev.gif';
import ColoredBanner from '../components/ColoredBanner';
import {MDXProvider} from '@mdx-js/react';
config.autoAddCss = false;
const NewsTemplate = ({pageContext, location, children}) => {
  const text = pageContext.body ?? '';
  const wpm = 225;
  const words = text.trim().split(/\s+/).length;
  const time = Math.ceil(words / wpm);
  const mainContent = useRef(null);
  const childrenEscapedBody = children.props.pageContext.body.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  let childrenEscaped = children;
  childrenEscaped.props.pageContext.body = childrenEscapedBody;
  if (!pageContext) return null;
  return React.createElement(Layout, {
    location: location,
    title: pageContext.frontmatter.title,
    description: pageContext.frontmatter.metaDesc,
    image: pageContext.ogImage?.absolutePath?.includes('placeholder') ? '' : pageContext.ogImage,
    lang: "de",
    noEnglish: true
  }, React.createElement(Container, null, React.createElement(ColoredBanner, {
    backgroundColor: "green",
    image: pageContext.image?.absolutePath?.includes('placeholder') ? '' : pageContext.image,
    title: pageContext.frontmatter.title,
    subHeadline: React.createElement("span", {
      className: "small text-muted w-100"
    }, React.createElement(FontAwesomeIcon, {
      icon: faCalendar
    }), "  ", pageContext.date, " ", React.createElement("span", {
      className: "mx-2"
    }, "|"), " ", React.createElement(FontAwesomeIcon, {
      icon: faUser
    }), "  Autor: ", pageContext.frontmatter.author, " ", React.createElement("span", {
      className: "mx-2"
    }, "|"), " ", React.createElement(FontAwesomeIcon, {
      icon: faClock
    }), "  Lesezeit ca. ", time, " Minute(n) ")
  }, React.createElement("p", {
    className: "mt-2"
  }, pageContext.frontmatter.intro)), React.createElement(Row, null, React.createElement(Col, {
    xs: 11,
    md: 10,
    id: "main-content",
    className: "mx-auto",
    ref: mainContent
  }, React.createElement("div", {
    className: "news-details"
  }, React.createElement(MDXProvider, null, childrenEscaped)))), React.createElement(Row, {
    className: "mt-5"
  }, React.createElement(Col, {
    xs: 11,
    md: 10,
    className: "mx-auto text-center"
  }, React.createElement("div", {
    className: "big-fat-red mb-5"
  }, "Über uns."), React.createElement("p", {
    className: "pb-3"
  }, " Statt Dienstleistungen an der Oberfläche bieten wir Ihnen vom ersten Moment an maßgeschneiderte Lösungen für Ihre Anforderungen. ganztags. ist nah an Ihren Themen und identifiziert sich damit wie einer Ihrer Mitarbeiter. Unsere Kunden durchlaufen keine Ebenen von Projekt- und Produktmanagern. Unser Team spricht direkt 1-zu-1 mit dem Kunden. Somit halten wir nicht nur den Wasserkopf, sondern auch das Budget auf einem nötigen Niveau."), React.createElement("hr", {
    className: "p-3"
  }))), React.createElement(Row, null, React.createElement(Col, {
    xs: 11,
    md: 10,
    className: "mx-auto py-2"
  }, React.createElement("p", {
    className: "text-center"
  }, " Wie wir die Wünsche unserer Kunden erfüllen, erklärt", React.createElement("a", {
    href: "/leistungen/",
    className: "semi-bold d-block"
  }, " unsere Arbeitsweise.")))), React.createElement(Row, null, React.createElement("a", {
    href: "/leistungen/#seo",
    className: "col-6 col-md my-3 text-center h-355"
  }, React.createElement("img", {
    src: SEOIMG,
    height: "120",
    className: "mt-5 mb-4 d-block",
    alt: "Suchmaschinenoptimierung"
  }), React.createElement("strong", null, "SEO"), React.createElement("div", {
    className: "my-3"
  }, "Optimierung für Suchmaschinen"), React.createElement("div", {
    className: "shadow-block"
  })), React.createElement("a", {
    href: "/leistungen/#sea",
    className: "col-6 col-md my-3 text-center h-355"
  }, React.createElement("img", {
    src: SEA,
    height: "120",
    className: "mt-5 mb-4 d-block",
    alt: "Suchmaschinenoptimierung"
  }), React.createElement("strong", null, "SEA"), React.createElement("div", {
    className: "my-3"
  }, " Werbung in ", React.createElement("br"), " Suchmaschinen"), React.createElement("div", {
    className: "shadow-block"
  })), React.createElement("a", {
    href: "/leistungen/#cro",
    className: "col-6 col-md my-3 text-center h-355"
  }, React.createElement("img", {
    src: CRO,
    height: "120",
    className: "mt-5 mb-4 d-block",
    alt: "Conversion Rate Optimierung"
  }), React.createElement("strong", null, "CRO"), React.createElement("div", {
    className: "my-3"
  }, " Conversion Rate ", React.createElement("br"), " Optimierung"), React.createElement("div", {
    className: "shadow-block"
  })), React.createElement("a", {
    href: "/leistungen/#design",
    className: "col-6 col-md my-3 text-center h-355"
  }, React.createElement("img", {
    src: DESIGN,
    height: "120",
    className: "mt-5 mb-4 d-block",
    alt: "Design"
  }), React.createElement("strong", null, "Design"), React.createElement("div", {
    className: "my-3"
  }, " UI/UX und ", React.createElement("br"), " Corporate Design"), React.createElement("div", {
    className: "shadow-block"
  })), React.createElement("a", {
    href: "/leistungen/#dev",
    className: "col-12 col-md mt-3 text-center h-355"
  }, React.createElement("img", {
    src: DEV,
    height: "120",
    className: "mt-5 mb-4 d-block",
    alt: "Technische Entwicklung"
  }), React.createElement("strong", null, "DEV"), React.createElement("div", {
    className: "mt-3"
  }, "Webentwicklung"), React.createElement("div", {
    className: "shadow-block"
  })))), React.createElement(Contact));
};
NewsTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(NewsTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
